import React, { useEffect, useState } from "react";
import "./Cancel_order.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowLeft,
  faCircleChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
// import Select_reason_heading from "../../common-components/select_reason_heading/Select_reason_heading";
// import Reason_cancelling_field_holder from "../../common-components/reason_cancelling_field_holder/Reason_cancelling_field_holder";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import Order_details_table from "./order_details_table/Order_details_table";
import Reason_cancelling_field_holder from "../../common_components/reason_cancelling_field_holder/Reason_cancelling_field_holder";
import Select_reason_heading from "../../common_components/select_reason_heading/Select_reason_heading";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../features/order/orderSlice";
import { decodeId, encodeId, formatDate } from "../../../utils/common";
import { getAllCancelReason } from "../../../features/master/masterSlice";

function Cancel_order() {
  const { id } = useParams();
  const [orderId, setOrderId] = useState(null); // decoded ID

  useEffect(() => {
    if (id) {
      const decoded = decodeId(id);
      setOrderId(decoded);
    }
  }, [id]);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "ORDER DETAILS", link: "/order-details", isActive: false },
    { label: "CANCEL ORDER", link: "", isActive: true },
  ];

  const [cancelReason, setCancelReason] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [cancelReasonId, setCancelReasonId] = useState(null);
  const [cancelReasonName, setCancelReasonName] = useState(null);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const cancelorder = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
    } else if (res.meta?.requestStatus === "rejected") {
    }
  }, [dispatch]);

  const reason = useSelector((state) => state.master.cancelReasons);
  useEffect(() => {
    // Ensure ID is valid before dispatching
    dispatch(getAllCancelReason());
  }, [dispatch]);
  return (
    <>
      <section className="Cancel_order">
        <div className=" cancel_order_holder">
          <div className="container">
            <div className="title_holder">
              <div className="heading_holder">
                <h4>
                  <Link to={`/order-details/${id}`}>
                    <FontAwesomeIcon
                      className=" arrow_icon me-sm-3 me-2"
                      icon={faCircleChevronLeft}
                    />
                  </Link>{" "}
                  Cancel Order
                </h4>
              </div>

              <div className="text_holder">
                <h6>{`Order ID #${cancelorder?.invoice_no}`}</h6>
                <h5>{formatDate(cancelorder?.createdAt)}</h5>
              </div>
            </div>

            <Order_details_table
              type="Cancel"
              setError={setError}
              error={error}
              order={cancelorder}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
            />

            <Select_reason_heading
              type="Cancel"
              reason={reason}
              setError={setError}
              error={error}
              cancelReasonId={cancelReasonId}
              setCancelReasonId={setCancelReasonId}
              setCancelReasonName={setCancelReasonName}
              cancelReasonName={cancelReasonName}
            />

            <Reason_cancelling_field_holder
              type="Cancel"
              setError={setError}
              error={error}
              order={cancelorder}
              cancelReason={cancelReason}
              setCancelReason={setCancelReason}
              selectedItems={selectedItems}
              cancelReasonId={cancelReasonId}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Cancel_order;
